import FormatWorker from "workers/formatSql";

const worker = new FormatWorker();

export const format = (sql: string, config: any, signal?: AbortSignal) => {
  return worker.format(sql, config, signal);
};
